module.exports = "<div class=\"branded-logo\"> <img ng-src=\"{{$ctrl.src}}\" alt=\"Logo\" width=\"100%\" height=\"auto\"> </div>";